import routerOptions0 from "/nuxtWeb/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.150.0_@parcel+watcher@2.6.0_@types+node@26.6.2_@vue+compile_ssy2vvwtmx6o443cks5bcllykq/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}